/* eslint-disable no-param-reassign */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { initialize } from "../../actions";
import { FEATURE_NAME, withNamespace } from "../../constants/namespace";
import { LISTING_AGENT_MATCHES } from "../../graphql-documents/listingAgentMatches.query";

const fetchAgentMatches = createAsyncThunk(
  withNamespace("fetchAgentMatches"),
  async (propertyId, { extra }) => {
    const { analyticsService, graphqlQueryService } = extra[FEATURE_NAME];

    return graphqlQueryService
      .query({
        query: LISTING_AGENT_MATCHES,
        variables: { propertyId }
      })
      .then(({ data }) => {
        const agentMatch = data.listing_agent_matches[0];

        analyticsService.sendImpressionsForListingAgentEvent({
          expertContactId: agentMatch.contact_id,
          propertyId
        });

        return agentMatch;
      });
  }
);

const initialState = {
  propertyId: null
};

const agentMatchSlice = createSlice({
  name: withNamespace("agentMatch"),
  initialState,
  reducers: {},
  extraReducers: {
    [initialize]: (state, action) => {
      const { propertyId } = action.payload;

      state.propertyId = propertyId;
    },
    [fetchAgentMatches.fulfilled]: (state, { payload }) => {
      state.agentImageSrc = payload.photo_url;
      state.agentName = payload.name;
      state.agentTitle = payload.license_type;
      state.brokerage = payload.brokerage;
      state.brokerageAddress = payload.brokerage_address;
      state.contactId = payload.contact_id;
      state.isPro = payload.is_pro;
      state.medianSalesPrice = payload.median_sales_price;
      state.nearbyHomes = payload.homes_sold_nearby;
      state.recentHomesSold = payload.homes_sold_recent;
      state.similarHomes = payload.homes_sold_similar;
      state.soldHomesInUserBuilding = payload.has_sold_in_building;
      state.yearsExperience = payload.years_experience;
      state.uuid = payload.uuid;
      state.profileUrl = payload.profile_url;
    }
  }
});

export default agentMatchSlice.reducer;
export { fetchAgentMatches };
